<template>
  <section>
    <form action="">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Edit Project</p>
        </header>

        <section class="modal-card-body">
          <b-field label="Project Name">
            <b-input
              type="text"
              v-model="project.name">
            </b-input>
          </b-field>

          <b-field label="Project Description">
            <b-input
              type="text"
              v-model="project.description">
            </b-input>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <!-- <button class="button" type="button" @click="$parent.close()">Close</button> -->
          <button class="button is-primary" @click="saveProject">Save</button>
        </footer>

      </div>
    </form>
</section>
</template>

<script>
import firebase from 'firebase';

export default {
  props: [ 'project' ],
  mounted() {
    this.currentUser = firebase.auth().currentUser;
  },
  methods: {
    saveProject() {
      this.project.updated = Date.now();
      var updates = {};
      updates['/users/' + this.currentUser.uid + '/projects/' + this.project.id] = this.project;

      firebase.database().ref().update(updates).then(() => {
        this.$parent.close();
      });
    }
  },
  beforeDestroy() {
    this.saveProject();
  },
}
</script>


// WEBPACK FOOTER //
// src/components/EditProject.vue